// Ticks a launch countdown toward the ISO date in its data-end attribute.
class SCountdown extends HTMLElement {
  #timerId = 0;

  connectedCallback() {
    this.end = Date.parse(this.dataset.end || '');
    if (Number.isNaN(this.end)) return;
    this.units = {
      days: this.querySelector('[data-unit="days"]'),
      hours: this.querySelector('[data-unit="hours"]'),
      minutes: this.querySelector('[data-unit="minutes"]'),
      seconds: this.querySelector('[data-unit="seconds"]'),
    };
    this.#tick();
    this.#timerId = window.setInterval(() => this.#tick(), 1000);
  }

  disconnectedCallback() {
    window.clearInterval(this.#timerId);
  }

  #tick() {
    const remaining = Math.max(0, this.end - Date.now());
    const totalSeconds = Math.floor(remaining / 1000);
    const values = {
      days: Math.floor(totalSeconds / 86400),
      hours: Math.floor((totalSeconds % 86400) / 3600),
      minutes: Math.floor((totalSeconds % 3600) / 60),
      seconds: totalSeconds % 60,
    };
    for (const [unit, el] of Object.entries(this.units)) {
      if (el) el.textContent = String(values[unit]).padStart(2, '0');
    }
    if (remaining === 0) window.clearInterval(this.#timerId);
  }
}

if (!customElements.get('s-countdown')) customElements.define('s-countdown', SCountdown);
